export const SHOW_MODAL = 'SHOW_MODAL';

export const HIDE_MODAL = 'HIDE_MODAL';

export const SHOW_PREVIOUS_MODAL = 'SHOW_PREVIOUS_MODAL';
